export default function initHeaderHideShow() {
  const header = document.querySelector('.header');
  const downClass = 'scrolled-down';
  const pinnedClass = 'is-pinned';
  let lastScroll = 0;

  if (!header) return;

  function updateHeaderClass() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  
    if (currentScroll > lastScroll) {
      header.classList.add(downClass);
    } else {
      header.classList.remove(downClass);
    }

    if (currentScroll >= header.clientHeight/2) {
      header.classList.add(pinnedClass);
    } else{
      header.classList.remove(pinnedClass);
    }
  
    lastScroll = currentScroll;
  }
  
  updateHeaderClass()
  window.addEventListener('scroll', updateHeaderClass);
}